module.exports = __webpack_public_path__ + "img/logo.256496dd.png";